<template>
  <div id="callback" style="background-image: url(https://aatgeniemedia.blob.core.windows.net/assets/web/ambient-bubbles.png);">
    <v-container fluid justify-center>
      <v-img
        :src="imageUri_Background"
        height="800"
        >
        <v-row justify="center" class="my-3">
          <span :class="messageClass">
            <span v-if="message.length === 0">Signing in...</span>
            <span>{{ message }}</span>
          </span>
        </v-row>
      </v-img>
    </v-container>
  </div>
</template>

<script>
import { AppColor, ImageUri } from '@/config.js'

export default {
  name: 'Callback',
  data() {
    return {
      // colors
      appColor_Medium: AppColor.Medium,

      // uri
      imageUri_Background: ImageUri.Background,
    }
  },
  computed: {
    authenticated () {
      return this.$auth.isAuthenticated
    },
    auth0Client () {
      return this.$auth.auth0Client
    },
    message () {
      if (this.$route.query.message === undefined) return ''
      return this.$route.query.message
    },
    messageClass () {
      const fontMSmall = 'headline'
      const fontLarge = 'display-1'
      const common = 'font-weight-black blue-grey--text text--lighten-5'
      return this.isSmallDevice
        ? `${fontMSmall} ${common} mb-0`
        : `${fontLarge} ${common} mb-10`
    },
  },
  methods: {
    async signIn () {
      this.drawer = false
      await this.$auth.loginWithRedirect()
    }
  },
  watch: {
    authenticated (val) {
      if (val) {
        this.$router.push('/')
      }
    },
    auth0Client (val) {
      if (val !== null) {
        if (this.$route.query.success !== undefined) {
          if (this.$route.query.success === 'true') {
            this.signIn()
          } else if (this.$route.query.success === 'false') {
            this.$error.show({
              title: 'Password Reset Error',
              text: this.message
            })
          }
        }
      }
    }
  }
}

</script>

<style>
#callback {
  background-size: cover;
  background-attachment: fixed;
  height: 90vh;
  text-align: center;
}
</style>